module.exports = __webpack_public_path__ + "static/media/logo-boxmi-footer.1b7de0dc.svg";